import { Injectable, computed, signal } from '@angular/core';

export const CADIX_ROW_FOCUS_LIMIT = 50;

@Injectable({ providedIn: 'root' })
export class CadixRowFocusService {
  readonly selectedRowIds = signal<readonly string[]>([]);
  readonly selectedCount = computed(() => this.selectedRowIds().length);
  readonly exceedsLimit = computed(() => this.selectedCount() > CADIX_ROW_FOCUS_LIMIT);
  readonly requestRowIds = computed<readonly string[]>(() =>
    this.exceedsLimit() ? [] : this.selectedRowIds(),
  );

  private clearGridSelection: (() => void) | null = null;

  setSelection(rowIds: readonly string[]): void {
    this.selectedRowIds.set([...new Set(rowIds.filter(Boolean))]);
  }

  bindGridClear(handler: () => void): () => void {
    this.clearGridSelection = handler;
    return () => {
      if (this.clearGridSelection === handler) {
        this.clearGridSelection = null;
      }
    };
  }

  clear(): void {
    this.clearGridSelection?.();
    this.selectedRowIds.set([]);
  }

  reset(): void {
    this.clearGridSelection = null;
    this.selectedRowIds.set([]);
  }
}
